import React, { useEffect, useState } from "react"

const API_BASE = process.env.GATSBY_API_BASE_URL

export type Props = {
  language: "en" | "ja"
}

type hotelData = {
  display_flag: boolean
  url: string
  url_en: string
  id: string
  password: string
}

const HotelInformation: React.FC<Props> = ({ language }) => {
  const [hotelData, setHotelData] = useState<hotelData>()

  let template = <></>
  if (hotelData?.display_flag) {
    switch (language) {
      case "en":
        template = (
          <>
            <h3>
              Special Website for Room Reservations for Loisir Hotel Toyohashi
            </h3>
            <p>
              The information shown below will be required for Customer
              Registration.
            </p>
            <ul>
              <li>Company ID: {hotelData.id}</li>
              <li>Company Password: {hotelData.password}</li>
            </ul>
            <a href={hotelData.url_en}>
              Click Here to the Special Website for Room Reservation for Loisir
              Hotel Toyohashi
            </a>
          </>
        )
        break
      case "ja":
        template = (
          <>
            <h3>ロワジールホテル豊橋 宿泊予約特設サイト</h3>
            <p>お客様登録の際、下記の情報が必要です。</p>
            <ul>
              <li>企業ID : {hotelData.id}</li>
              <li>企業パスワード : {hotelData.password}</li>
            </ul>
            <a href={hotelData.url}>
              ロワジールホテル豊橋 宿泊予約特設サイトはこちら
            </a>
          </>
        )
        break
    }
  }

  useEffect(() => {
    fetch(`${API_BASE}/hotel_reservation`)
      .then(response => response.json())
      .then(data => setHotelData(data))
  }, [])

  return template
}

export default HotelInformation
